import {gql} from '@apollo/client';

export default gql`
    query me {
      me {
        id
        email
        full_name
        image_url
        is_active
        created_at
        updated_at
        last_login_at
      }
    }
`;
